import * as React from "react";
import { RouterProvider } from "./Router";
import { AuthProvider } from "./Auth";
import { AppProvider } from "./App";
export function RootProvider(_a) {
    var children = _a.children;
    return (React.createElement(AuthProvider, null,
        React.createElement(AppProvider, null,
            React.createElement(RouterProvider, null, children))));
}



//////////////////
// WEBPACK FOOTER
// ./src/context/RootProvider.tsx
// module id = 45
// module chunks = 1